import TableContainer from "components/Common/TableContainer";
import en from "date-fns/locale/en-US";
import ko from "date-fns/locale/ko";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import "react-toastify/dist/ReactToastify.css";
import { CardBody, CardHeader, Col, Container, Row } from "reactstrap";
import { useRole } from "components/Hooks/UserHooks";
import { formatDateStringToKorea } from "helpers/format";
import CountUp from "react-countup";
import CreateEditCareer from "./component/CreateEditCareer";
registerLocale("en", en);
registerLocale("ko", ko);

const CareerTab = ({ data, handleUpdateSuccess }: { data: any, handleUpdateSuccess?: any }) => {
  const { t, i18n } = useTranslation();
  const { userPermissions } = useRole();

  const [query, setQuery]: any = useState({
    page: 1,
    limit: 30,
    keyword: "",

    sortBy: "created_at",
    orderBy: "DESC",
  });

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [itemToEdit, setItemToEdit] = useState<any>(false);
  const [linkImage, setLinkImage] = useState<any>(null);
  const [workExperiences, setWorkExperiences] = useState<any>([]);

  const onCloseImageClick = () => {
    setLinkImage(null);
  };

  // Column
  const columns = useMemo(
    () => [
      {
        Header: t("No."),
        thWidth: 50,
        thClass: "whitespace-nowrap",
        Cell: ({ ...props }) => {
          return (
            <div>
              {workExperiences?.length - props?.row?.index}
            </div>
          );
        },
      },
      {
        Header: t("Workplace Name"),
        accessor: "workplace",
        filterable: true,
        sortable: false,
        thWidth: 200,
        Cell: (cell: any) => {
          const title = cell?.value;
          return (
            <>
              <div className="cursor-pointer" style={{ minWidth: "200px" }}>
                {title}
              </div>
            </>
          );
        },
      },
      {
        Header: t("Start Date"),
        accessor: "startDate",
        filterable: true,
        sortable: false,
        thWidth: 130,
        thClass: "align-middle text-end whitespace-nowrap",
        Cell: (cell: any) => {
          const date = formatDateStringToKorea(cell?.value);
          const arrDate = String(date || "").split(" ");

          return (
            <div className="text-end" style={{ minWidth: "120px" }}>
              {cell?.value ? (
                <span>
                  <span>{arrDate?.[0] || ""}</span> <br />{" "}
                  <span className="text-secondary">{arrDate?.[1] || ""}</span>{" "}
                </span>
              ) : (
                "-"
              )}
            </div>
          );
        },
      },
      {
        Header: t("End Date"),
        accessor: "endDate",
        filterable: true,
        sortable: false,
        thWidth: 130,
        thClass: "align-middle text-end whitespace-nowrap",
        Cell: (cell: any) => {
          const date = formatDateStringToKorea(cell?.value);
          const arrDate = String(date || "").split(" ");

          return (
            <div className="text-end" style={{ minWidth: "120px" }}>
              {cell?.value ? (
                <span>
                  <span>{arrDate?.[0] || ""}</span> <br />{" "}
                  <span className="text-secondary">{arrDate?.[1] || ""}</span>{" "}
                </span>
              ) : (
                "-"
              )}
            </div>
          );
        },
      },
      {
        Header: t("Position"),
        accessor: "position",
        thClass: "text-center whitespace-nowrap",
        filterable: true,
        sortable: false,
        thWidth: 200,
        Cell: (cell: any) => {
          const name = cell?.value;
          return (
            <>
              <div className="cursor-pointer text-center" >
                {name || "-"}
              </div>
            </>
          );
        },
      },
      {
        Header: t("Job Description"),
        accessor: "description",
        thClass: "whitespace-nowrap",
        filterable: true,
        sortable: false,
        thWidth: 200,
        Cell: (cell: any) => {
          const description = cell?.value;
          return (
            <>
              <div className="cursor-pointer" >
                {description || "-"}
              </div>
            </>
          );
        },
      },
      // {
      //   Header: t("Created at"),
      //   accessor: "createdAt",
      //   filterable: false,
      //   sortable: false,
      //   thWidth: 150,
      //   thClass: "text-end",
      //   Cell: (cell: any) => {
      //     const date = formatDateStringToKorea(cell?.value);
      //     const arrDate = String(date || "").split(" ");

      //     return (
      //       <div className="text-end" style={{ minWidth: "120px" }}>
      //         <span>
      //           <span>{arrDate?.[0] || ""}</span> <br />{" "}
      //           <span className="text-secondary">{arrDate?.[1] || ""}</span>{" "}
      //         </span>
      //       </div>
      //     );
      //   },
      // },
    ],
    [i18n?.language, workExperiences?.length]
  );

  const handleChangePage = useCallback((page: any) => {
    setQuery({ page: page + 1 });
  }, []);

  const handleChangeSorting = useCallback((sortBy: any) => {
    setQuery((_prev: any) => {
      return { ..._prev, ...sortBy };
    });
  }, []);

  useEffect(() => {
    if (data) {
      setWorkExperiences(data?.workExperiences)
    }
  }, [data])

  useEffect(() => {
    document.title = `${t("Career")}| OnnyJob`;
    document.body.classList.remove("vertical-sidebar-enable");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n?.language]);

  return (
    <React.Fragment>
      <div>
        <Container fluid>
          <Row>
            <Col lg={12}>
              <div
                id="customerList"
                style={{ boxShadow: "0px 3px 4px 0px rgba(0, 0, 0, 0.03)" }}
              >
                <CardHeader className="border-0">
                  <Row className="g-4 align-items-center">
                    <div className="col-sm">
                      <div>
                        <h5 className="card-title mb-0">
                          <span className="me-2">{t("Total")}:</span>
                          <CountUp
                            start={0}
                            end={workExperiences?.length || 0}
                            duration={1}
                            className="text-primary"
                          />
                        </h5>
                      </div>
                    </div>
                    <div className="col-7 con-sm-6 text-end">
                      <div className="col-sm-auto">
                        <div>
                          <button
                            type="button"
                            className="btn btn-success add-btn"
                            // className="btn btn-success add-btn rounded-pill"
                            id="create-btn"
                            onClick={() => setIsOpen((_prev) => true)}
                          >
                            <i className="ri-add-line align-bottom me-1"></i>
                            {t("Button Add")}
                          </button>
                        </div>
                      </div>
                    </div>
                  </Row>
                </CardHeader>

                <CardBody className="pt-3">
                  <div>
                    <TableContainer
                      className="custom-header-css"
                      divClass="table-responsive table-card"
                      tableClass="align-middle table-bordered-dashed"
                      theadClass="table-light text-muted"
                      columns={columns}
                      data={workExperiences?.length ? workExperiences : []}
                      customPageSize={query.limit}
                      customPageIndex={query.page - 1}
                      totalRecords={workExperiences?.length}
                      handleChangePage={handleChangePage}
                      manualSorting={true}
                      sorting={{
                        sortBy: query.sortBy,
                        orderBy: query.orderBy,
                      }}
                      handleChangeSorting={handleChangeSorting}
                      isLoading={isLoading}
                      defaultScrollBottom={(workExperiences ?? [])?.length < 5 ? true : false}
                    />
                  </div>
                </CardBody>
              </div>
            </Col>
          </Row>
        </Container>

        {isOpen && (
          <CreateEditCareer
            setIsOpen={setIsOpen}
            item={itemToEdit}
            userID={data?.id}
            setItemToEdit={setItemToEdit}
            handleUpdateSuccess={handleUpdateSuccess}
            linkImage={linkImage}
            setLinkImage={setLinkImage}
            onCloseImageClick={onCloseImageClick}
          />
        )}
      </div>
    </React.Fragment>
  );
};

export default CareerTab;
